/// <reference types="@angular/localize" />

import { registerLocaleData } from '@angular/common';
import localeArEG from '@angular/common/locales/ar-EG';
import { LOCALE_ID } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { App } from './app/app';
import { appConfig } from './app/app.config';
import { loadRuntimeTranslations, pickLocale } from './app/core/i18n/locale-bootstrap';
import { environment } from './environments/environment';

// Register AR locale data so DatePipe/CurrencyPipe/NumberPipe + Material
// date adapter format dates/numbers/currency correctly when LOCALE_ID
// is ar-EG. EN is the default Angular locale; no registration needed.
registerLocaleData(localeArEG);

// Sentry — env-driven. The SDK is dynamically imported so its ~140kB
// raw weight stays out of the initial bundle when DSN is empty (dev,
// test) AND moves to a lazy chunk when it's set (production). The
// import call is non-blocking; the app boots immediately, error
// capture lights up moments later. PII is opted out by default;
// production replays are NOT enabled (educational platform; risk too
// high).
if (environment.sentryDsn) {
  void import('@sentry/angular').then((Sentry) => {
    Sentry.init({
      dsn: environment.sentryDsn,
      environment: environment.sentryEnvironment,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: environment.sentryTracesSampleRate,
      sendDefaultPii: false,
    });
  });
}

// Phase M.4 — fetch the runtime locale payload BEFORE bootstrap so
// loadTranslations() is in place when components evaluate their
// $localize tagged templates. Non-blocking on failure: the app boots
// in source-language (English) if the endpoint is unavailable.
//
// Also provide LOCALE_ID at bootstrap time so Angular's locale-aware
// pipes (DatePipe, CurrencyPipe, NumberPipe) + Material date adapter
// pick the right format for the picked locale. Pre-M.4 this was set
// by the per-locale build; now we provide it dynamically.
loadRuntimeTranslations()
  .catch(() => {
    // Swallow — pickLocale() falls back to source language anyway.
  })
  .finally(() => {
    const locale = pickLocale();
    const localeId = locale === 'ar' ? 'ar-EG' : 'en-US';
    bootstrapApplication(App, {
      ...appConfig,
      providers: [...(appConfig.providers ?? []), { provide: LOCALE_ID, useValue: localeId }],
    }).catch((err) => console.error(err));
  });

